<template>

<core-panel>

	<template v-slot:head>

		<h1>{{ typeName }}</h1>

		<p>The most common in the collection. Excludes expansions.</p>

	</template>

	<template v-slot:body>

		<app-thing v-for="(item, index) in types" :item="item" v-bind:key="index" v-on:more="onTypeClick" :dark="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'types',
			params: [
				'filter'
			],
			types: []
		}

	},

	computed: {

		typeName: function() {

			return (this.data.filter) ? ((this.data.filter.type === 'category') ? 'Categories' : 'Mechanics') : ''

		}

	},

	methods: {

		response: function(json) {

			this.types = json.types

		},

		onTypeClick: function(id) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsCollectionType',
				id: id,
				filter: this.$store.getters['filter/insights/collection'],
				child: true
			})

		}

	}

}

</script>